module.exports = __webpack_public_path__ + "static/media/master_setting_black.4bad500c.svg";